<template>
  <tr>
    <td>
      <a
        link
        @click.stop="gotToReference()"
      >
        {{ item.reference.name }} - {{ item.reference.description }}
      </a>
    </td>
    <td>{{ item.product.name }} ({{ item.product.ref }})</td>
    <td class="text-center">
      
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span 
            class="chip mb-2"
            :style="'background-color: ' + item.color.hexacode"
            v-bind="attrs"
            v-on="on"
          ></span>
        </template>
        {{ item.color.name }}
      </v-tooltip>
    <td>{{ item.size.name }}</td>
    <td>{{ getUnitPrice | toPrice(2, '€ HT') }}</td>
    <td>x {{ item.quantity }}</td>
    <td>{{ itemTotal | toPrice(2, '€ HT') }}</td>
  </tr>
</template>

<script>
  // MIXINS
  import utils from '@/mixins/utils'

  export default {
    name: 'Item',

    mixins: [utils],

    props: {
      item: Object,
    },

    computed: {
      itemTotal() {
        return (this.item.quantity * this.getUnitPrice)
      },
      getUnitPrice() {
        if (this.item.discount !== null) {
          return this.item.unitPrice * (1 - this.item.discount)
        }

        return this.item.unitPrice
      },
    },

    methods: {
      gotToReference() {
        this.$router.push({
          name: 'ShowReference', 
          params: {
            id: this.item.reference.id,
          },
        })
      }
    },
  }
</script>

<style scoped>
  .chip {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #000;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .white-text {
    color: #fff;
  }
  .black-text {
    color: #000;
  }
</style>